module.exports = "/_next/static/images/banner_icon_shindan-72c52d786407c305b098b25fc5cb1911.svg";